import { takeLatest, call, put, select } from 'redux-saga/effects';
import DomPurify from 'dompurify';
import axios from '../axiosConfig';
import { sendBrochureRequest, sendBrochureResponse } from '../../slices/brochure';
import getHotelPriceDisplayPreference from '../../../helpers/selectors/getHotelPriceDisplayPreference';

function* sendBrochureWorker({
  payload: {
    brochureId,
    savedBrochureId,
    createdFor,
    emailRecipients,
    emailSubject,
    fromEmail,
    emailMessage,
    doUpdatePriceOnPageLoad,
    doSendCopyToAgent,
    doShowPricing,
    doAllowBook,
    editorHTML,
    editorJSON,
    doShowBrochureEditor,
  },
}) {
  try {
    const hotelRateDisplayPreference = yield select(getHotelPriceDisplayPreference(true));
    const { email: loggedInUserEmail } = yield select((store) => store.user);
    const url = '/brochure/updateAndSend';
    const config = {
      method: 'post',
      url,
      data: JSON.stringify({
        loggedInUserEmail,
        createdFor,
        emailRecipients,
        emailSubject,
        fromEmail,
        emailMessage,
        brochureId: savedBrochureId,
        doUpdatePriceOnPageLoad,
        doSendCopyToAgent,
        doShowPricing,
        hotelRateDisplayPreference,
        doAllowBook,
        editorHTML:
          doShowBrochureEditor && editorHTML
            ? DomPurify.sanitize(editorHTML).replace(/(src|href)="\/\//g, '$1="https://')
            : '',
        editorJSON: doShowBrochureEditor ? editorJSON : '',
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const { data } = yield call(axios, config);

    if (data === false) {
      yield put(
        sendBrochureResponse({
          brochureId,
          error: 'We could not send this proposal email. Please try again or contact support.',
        }),
      );
      return;
    }

    yield put(
      sendBrochureResponse({
        brochureId,
      }),
    );
  } catch (error) {
    let errorMessage = 'We could not send this proposal. Please try again.';
    if (error && error.response && error.response.data) {
      const { title, detail } = error.response.data;
      errorMessage = detail || title || errorMessage;
    }
    yield put(
      sendBrochureResponse({
        brochureId,
        error: errorMessage,
      }),
    );
  }
}

function* sendBrochureWatcher() {
  yield takeLatest(sendBrochureRequest.toString(), sendBrochureWorker);
}

export default sendBrochureWatcher;
